<template>
  <a-card :bordered="false" title="价格规则">
    <div class="content-main">
      <ul>
        <li>本系统价格</li>
        <li>建议销售价</li>
        <li>同行价</li>
        <li>佣金</li>
        <li>市场价</li>
        <li>采购价</li>
      </ul>
      <ul class="right-box">
        <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;绿云PMS系统价格</li>
        <li>= &nbsp;&nbsp;&nbsp;渠道卖价 + 渠道卖价 *
          <a-input-number placeholder="0-100" v-model="salePriceRate" @change="onChange" :min="0" :max="100"
                          :precision="0"/>
          % +
          <a-input-number placeholder="0-10000" v-model="salePriceAdd" @change="onChange" :min="0" :max="10000"
                          :precision="0"/>
          元
        </li>
        <li>= &nbsp;&nbsp;&nbsp;渠道卖价 + 渠道卖价 *
          <a-input-number placeholder="0-100" v-model="peerPriceRate" @change="onChange" :min="0" :max="100"
                          :precision="0"/>
          % +
          <a-input-number placeholder="0-10000" v-model="peerPriceAdd" @change="onChange" :min="0" :max="10000"
                          :precision="0"/>
          元
        </li>
        <li>= &nbsp;&nbsp;&nbsp;渠道卖价 *
          <a-input-number placeholder="0-100" v-model="commissionRate" @change="onChange" :min="0" :max="100"
                          :precision="0"/>
          % +
          <a-input-number placeholder="0-10000" v-model="commissionAdd" @change="onChange" :min="0" :max="10000"
                          :precision="0"/>
          元
        </li>
        <li>= &nbsp;&nbsp;&nbsp;渠道卖价 + 渠道卖价 *
          <a-input-number placeholder="0-100" v-model="marketPriceRate" :min="0" :max="100" :precision="0"/>
          % +
          <a-input-number placeholder="0-10000" v-model="marketPriceAdd" :min="0" :max="10000"
                          :precision="0"/>
          元
        </li>
        <li>= &nbsp;&nbsp;&nbsp;渠道卖价

        </li>
      </ul>
    </div>
    <div style="padding-left:90px;">
      <a-button type="primary" @click="handleSubmit">保存</a-button>
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'SynchronizationRules',
  data() {
    return {
      salePriceRate: 0,
      marketPriceRate: 0,
      commissionRate: 0,
      peerPriceRate: 0,

      marketPriceAdd: 0,
      commissionAdd: 0,
      peerPriceAdd: 0,
      salePriceAdd: 0,

      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      id: ''
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'PMSProductList', title: '同步商品' },
      { name: 'PMSDirectOrdersList', title: '订单直连' },
      { name: 'PMSAssociatedAccount', title: '关联账号' }
    ])
    this.getDetail()
  },
  methods: {
    onChange() {
      // if(this.commissionRate <0){
      //   this.$message.error('建议佣金百分比数值 ≥ 0')
      //   return
      // }
      // if(this.salePriceRate - this.peerPriceRate > this.commissionRate ){
      //   this.$message.error('建议销售价百分比数值 - 同行价百分比数值 ≤ 佣金百分比数')
      //   return
      // }
      // if(this.commissionAdd<0){
      //   this.$message.error('建议佣金 >= 0')
      //   return
      // }
      // if(this.salePriceAdd - this.peerPriceAdd > this.commissionAdd ){
      //   this.$message.error('建议销售价 - 同行价 <= 佣金')
      //   return
      // }
      // return true
    },
    getDetail() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('lvyun/link/findLvYunRules', params)
        .then(res => {
          this.peerPriceRate = res.peerPriceRate
          this.commissionRate = res.commissionRate
          this.marketPriceRate = res.marketPriceRate
          this.salePriceRate = res.salePriceRate

          this.salePriceAdd = res.salePriceAdd
          this.peerPriceAdd = res.peerPriceAdd
          this.commissionAdd = res.commissionAdd
          this.marketPriceAdd = res.marketPriceAdd
          this.id = res.id
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    handleSubmit() {
      // this.onChange
      // if(this.salePriceRate == null){
      //   this.$message.error('请输入销售价百分比')
      //   return
      // }
      // if(this.peerPriceRate == null){
      //   this.$message.error('请输入同行价百分比')
      //   return
      // }
      // if(this.commissionRate == null){
      //   this.$message.error('请输入佣金百分比')
      //   return
      // }
      // if(this.marketPriceRate == null){
      //   this.$message.error('请输入市场价百分比')
      //   return
      // }

      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        salePriceRate: this.salePriceRate,
        marketPriceRate: this.marketPriceRate,
        commissionRate: this.commissionRate,
        peerPriceRate: this.peerPriceRate,

        salePriceAdd: this.salePriceAdd,
        peerPriceAdd: this.peerPriceAdd,
        commissionAdd: this.commissionAdd,
        marketPriceAdd: this.marketPriceAdd,
        id: this.id
      }
      this.getHttpServices().getServerApiService().post('lvyun/link/editLvYunRules', params)
        .then(res => {
          this.id = res
          this.$message.success('成功保存')
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    }
  }
}
</script>

<style scoped lang="less">
.tips {
  font-size: 14px;
  padding-left: 15px;
}

ul, li {
  list-style: none;
  padding: 0;
}

.content-main {
  display: flex;

  ul {
    &:first-child {
      background: #E9E9E9;
    }

    li {
      height: 40px;
      line-height: 40px;
      padding: 0 10px;

      &:first-child {
        font-weight: bold;
      }
    }
  }
}
</style>